<template>
  <div class="kkllbb">
    <el-dialog :visible.sync="show" :showClose="false" width="700px">
      <div class="reservation">
        <div class="reservation-left">
          <div class="left-con">
            <div class="title">立即预约</div>
            <!-- <div class="title1">品质生活 就选极家家居</div> -->
          </div>
          <div class="left-con1">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="80px"
              class="demo-ruleForm"
            >
              <el-form-item label="姓名:" prop="customerName" class="hh">
                <el-input
                  v-model="ruleForm.customerName"
                  size="small"
                  placeholder="请输入您的姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="电话:" prop="customerPhone" class="hh">
                <el-input
                  v-model="ruleForm.customerPhone"
                  size="small"
                  placeholder="请输入电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="预约门店:" class="hh">
                <el-select
                  popper-append-to-body="false"
                  v-model="ruleForm.depart"
                  style="width: 220px"
                  placeholder="请选择预约门店"
                >
                  <el-option
                    v-for="item in storeList"
                    :key="item.code"
                    :label="item.departName"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="装修类型:" class="hh">
                <el-select
                  v-model="ruleForm.decorationType"
                  style="width: 220px"
                  placeholder="请选择装修类型"
                >
                  <el-option
                    v-for="item in decorationTypeList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <!-- <div class="bg">
              <van-field
                label-width="70"
                class="icon-size"
                v-model="value"
                label="姓名:"
                placeholder="请输入用户名"
              />
            </div>
            <div class="bg">
              <van-field
                label-width="70"
                class="icon-size"
                v-model="value"
                label="手机号:"
                placeholder="请输入手机号"
              />
            </div> -->
          </div>
          <div class="ff">
            <el-button
              type="danger"
              @click="submitForm('ruleForm')"
              class="btnclass"
              >立即预约</el-button
            >
          </div>
        </div>
        <div class="reservation-right">
          <div class="right-img">
            <van-icon name="close" class="closeico" @click="closeMed" />
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { datadict, storeList, reservationNew } from "@/api/acount.js";
import { DesignerAppointment } from "@/api/newerpapi.js";
import { Toast } from "vant";
import { debounce } from "@/utills/debounce.js";
//  import debounce from "@/utills/debounce"
export default {
  data: function () {
    return {
      decorationTypeList: [],
      storeList: [],
      show: false,
      ruleForm: {
        customerName: "",
        customerPhone: "",
        depart: "",
        decorationType: "",
      },
      rules: {
        customerName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        customerPhone: [
          { required: true, message: "请输入电话", trigger: "blur" },
          {
            required: true,
            pattern:
              /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    DecorationTypeList() {
      datadict("客户类型").then((res) => {
        this.decorationTypeList = res.data.data;
      });
    },
    // 门店列表
    storeListMed() {
      storeList().then((res) => {
        console.log(res);
        this.storeList = res.data.data;
      });
    },
    //  submitForm(formName) {
    submitForm: debounce(
      function (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            reservationNew(this.ruleForm)
              .then((res) => {
                console.log(res);
                if (res.data.statusCode == 200) {
                  var submitData = {
                    appointmentContext:
                      "{'name':'" +
                      this.ruleForm.customerName +
                      "','phone':'" +
                      this.ruleForm.customerPhone +
                      "'}",
                    appointmentSourceType: "3a83eb83fd4c402f908c7350c3ff44f7", //固定为渠道大屏来源（3a83eb83fd4c402f908c7350c3ff44f7）
                  };
                  DesignerAppointment(submitData).then((res) => {
                    console.log(res);
                    this.show = false;
                  });

                  this.show = false;
                  Toast.success("预约成功");
                }
              })
              .catch((err) => {
                console.log(err);
                Toast.fail("预约失败");
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      1000,
      true
    ),
    showPopup() {
      this.ruleForm.depart = window.sessionStorage.getItem("storeId");
      this.show = true;
      this.$refs.ruleForm?.resetFields();
      this.ruleForm.depart = "";
      this.ruleForm.decorationType = "";
      this.ruleForm.depart = window.sessionStorage.getItem("storeId");
      this.DecorationTypeList();
      this.storeListMed();
    },
    closeMed() {
      this.show = false;
    },
  },
  created() {
    // alert(window.sessionStorage.getItem("storeId"))
    // this.ruleForm.depart = window.sessionStorage.getItem("storeId");
  },
};
</script>

<style scoped>
.reservation {
  display: flex;
  height: 440px;
}
.reservation-left {
  /* border: 1px solid red; */
  flex: 1;
}
.left-con {
  padding: 30px 32px;
  background: white;
  /* border: 1px solid red; */
}
.reservation-right {
  flex: 1;
}
.right-img {
  height: 100%;
  background-image: url(@/assets/img/ljyy.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  position: relative;
  overflow: hidden;
}
.title {
  font-weight: 600;
  font-size: 20px;
  color: #2a2a2a;
}
.title1 {
  color: #999999;
}
.icon-size {
  font-size: 16px;
  color: #666666;
}
.left-con1 {
  padding: 0 20px;
}
.bg {
  /* background: red; */
  /* border: 1px solid red; */
  margin: 15px 0px;
}
.ff {
  text-align: center;
  margin-top: 40px;
}
.btnclass {
  width: 85%;
  background: #d22424;
}
.closeico {
  font-size: 34px;
  float: right;
  margin: 10px;
}
.closeico:hover {
  font-size: 34px;
  float: right;
  margin: 10px;
  color: white;
  cursor: pointer;
}
.hh >>> .el-input__inner {
  border: 0;
  background-color: #fafafa;
  padding: 0 0;
}
.hh {
  width: 100%;
  height: 43px;
  background: #fafafa;
}
.kkllbb >>> .el-dialog__header {
  padding: 0;
}
.kkllbb >>> .el-dialog__body {
  padding: 0;
}
</style>